import API from 'utils/api';
import { onError } from 'utils/handlers';
import { baseURI } from './empleados';

export const DESCRIPCION_PROCESO_SINCRONIZAR_FOTOS = 'Actualizar Fotografías Empleados EnigmaSuite';

export const postActualizarFotosEnigmaSuite = async () => {
  try {
    const response = await API.post(`${baseURI}/actualizar-fotos-enigmasuite/`);
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const postDetenerFotosEnigmaSuite = async () => {
  try {
    await API.post(`${baseURI}/detener-fotos-enigmasuite/`);
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
